import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Section, Eyebrow, SectionTitle } from './ui.jsx';
import { tokens, displayFont } from '../theme.js';

export default function Contact() {
  const { t } = useTranslation();
  const email = t('contact.email');

  return (
    <Section id="contact" sx={{ bgcolor: tokens.dark, color: '#fff' }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.1fr 0.9fr' }, gap: { xs: 5, md: 8 }, alignItems: 'center' }}>
        <Box>
          <Eyebrow onDark>{t('contact.eyebrow')}</Eyebrow>
          <SectionTitle onDark>{t('contact.title')}</SectionTitle>
          <Typography sx={{ color: tokens.mutedOnDark, maxWidth: '55ch', mt: -2 }}>{t('contact.body')}</Typography>
        </Box>
        <Paper sx={{ bgcolor: tokens.dark2, border: `1px solid ${tokens.lineOnDark}`, p: 4, boxShadow: 'none' }}>
          <Typography sx={{ fontFamily: displayFont, fontWeight: 600, fontSize: '1.15rem', color: '#fff' }}>{t('contact.cardTitle')}</Typography>
          <Typography sx={{ color: tokens.mutedOnDark, fontSize: '0.9rem', mt: 1, mb: 3 }}>{t('contact.cardBody')}</Typography>
          <Button variant="contained" href={`mailto:${email}`}>{t('contact.cta')}</Button>
          <Typography sx={{ color: tokens.mutedOnDark, fontSize: '0.8rem', mt: 2 }}>{email}</Typography>
        </Paper>
      </Box>
    </Section>
  );
}
